import { IANAZone } from "luxon";
import { is_on_mobile } from "../app";
import { Prog } from "../utils/Prog";
import ColorThief from "colorthief"

export class HeroBuilder {
  constructor(){
    this.auto_banner_data = null;
    try {
      this.events = JSON.parse(localStorage.getItem("events"));
      this.chain_events = JSON.parse(localStorage.getItem("chain_events"));

      if(!this.events){
          gl_api.getProg().then((prog) => {
            // console.log(prog)
            this.m_prog = prog;
            this.events = prog.schedule.events;
        })
      }
    } catch (err) {
      this.events = [];
      this.chain_events = [];
    }
  }

  $create(iParam) {
    const self = this;
    // console.log("HeroBuilder - $create", iParam)

    this.$hero_builder = $("<div/>").addClass(is_on_mobile() ? "mobile-hero-builder" : "hero-builder");

    if(iParam.type == "auto"){
      // console.log(gl_config.website.home_page_config)
      if(gl_config.type == "site"){
        if(!gl_config.website.home_page_config || (gl_config.website.home_page_config && gl_config.website.home_page_config.banner_type == "auto")){
          this.get_auto_banner_image();
        }else if(gl_config.website.home_page_config && gl_config.website.home_page_config.banner_type == "custom"){
          if(!gl_config.website.home_page_config.banner_media){
            return this.$hero_builder;
          }
          // console.log(gl_config.website.home_page_config.banner_media)
          let media = gl_config.website.home_page_config.banner_media;
          media.media_url = media.media_url.replace("/120x","/1920x");
          media.media_url = media.media_url.replace("/600x","/1920x");
          media.media_url = media.media_url.replace("/320","/1920");
          this.$createHero({
            "text_btn" : gl_config.website.home_page_config.text_btn_banner ? gl_config.website.home_page_config.text_btn_banner : _l("Réserver ma place"),
            "title" : gl_config.website.home_page_config.title_banner ? gl_config.website.home_page_config.title_banner : "",
            "url" : media.media_url,
            "action" : media.link && media.link.type != "none" ? (e) => {
                e.preventDefault();
                self.set_media_action(media)
            } : null
          }).appendTo(this.$hero_builder);
        }
      }else if(gl_config.type == "chain"){
        this.get_auto_banner_image();
      }
    }else if(iParam.type == "custom"){
      this.$createHero(iParam.data).appendTo(this.$hero_builder);
    }   

    return this.$hero_builder;
  }

  $createHero(iParam) {
    // console.log("HeroBuilder - $createHero", iParam)

    if(!iParam.default_img){
      const colorThief = new ColorThief();
      const img = new Image();
      img.addEventListener('load', function() {
          let rgb = colorThief.getColor(img);
          // console.log("HeroBuilder - rgb image",rgb[0]+rgb[1]+rgb[2])
          // if(rgb[0]+rgb[1]+rgb[2]>350){
          $("nav").removeClass("black white");
          $(".hero-movie-title").removeClass("black white");
          $(".hero-side").removeClass("black white");
          $(".hero-builder").removeClass("black white");
          if(rgb[0]+rgb[1]+rgb[2]>500){
              if(!gl_config.website.style || !gl_config.website.style.navbar_transparency || gl_config.website.style.navbar_transparency == "with"){
                $("nav").addClass("black");
              }
              $(".hero-movie-title").addClass("black");
              $(".hero-side").addClass("white");
              $(".hero-builder").addClass("white");
          }else{
              if(!gl_config.website.style || !gl_config.website.style.navbar_transparency || gl_config.website.style.navbar_transparency == "with"){
                $("nav").addClass("white");
              }
              $(".hero-movie-title").addClass("white");
              $(".hero-side").addClass("black");
              $(".hero-builder").addClass("black");
          }
      });
      img.crossOrigin = 'Anonymous';
      img.src = iParam.url;
    }
    
    let tab_title = iParam.title.split(":");
    let main_title = tab_title[0];
    let second_title = "";
    if(tab_title.length > 1){
      second_title = tab_title[1];
    }

    let img_url = iParam.url;
    if(is_on_mobile()){
      img_url = img_url.replace("/1920x","/960x");
      img_url = img_url.replace("/1920","/960");
    }else{
      // img_url = img_url.replace("/1920x","/960x");
      // img_url = img_url.replace("/1920","/960");
    }
    
    this.heroContainer = $("<div/>").addClass(is_on_mobile() ? "mobile-hero-container" : "hero-container").on("click", (e) => {
      if(iParam.action){
        iParam.action(e);
      }
    });
      this.heroImage = $("<img/>").attr({ id: "hero-img", src: img_url, "alt":iParam.title, "fetchpriority":"high"}).addClass(is_on_mobile() ? "mobile-hero-img" : "hero-img").appendTo(this.heroContainer);

    if(main_title || iParam.action){
      this.heroImage.addClass("hero-img-with-side");
      this.heroSide = $("<div/>").addClass("hero-side").appendTo(this.heroContainer);
      this.heroCallToActionContainer = $("<div/>").addClass("hero-call-to-action-container").attr({ id: "hero-call-to-action-container" }).appendTo(this.heroContainer);
        this.$main_title = $("<div/>").text(main_title).addClass("hero-movie-title h1").appendTo(this.heroCallToActionContainer);
        this.$second_title = $("<div/>").text(second_title).addClass("hero-movie-title second_title h3").appendTo(this.heroCallToActionContainer);
        if(iParam.action){
          this.$btn_call_to_action = $("<button>").text(iParam.text_btn ? iParam.text_btn : _l("Réserver ma place")).addClass(is_on_mobile() ? "mobile-call-to-action-btn" : "call-to-action-btn").appendTo(this.heroCallToActionContainer).on("click", (e) => {
            iParam.action(e);
          });
        }
    }
    return this.heroContainer;
  }

  async get_auto_banner_image(){

    this.$createHero({
      "text_btn" : _l("Réserver ma place"),
      "title" : ".",
      "url" : "https://images.monnaie-services.com/"+gl_config.theme.type+"_backdrop/240x/default.webp",
      "action" : () => {
        // window.location.href = `#showmovie?id=${movieDataToShow.id}`;
      },
      "default_img" : true
    }).appendTo(this.$hero_builder);

    try{
      const res_api = await gl_api.get_banner_image({"theme" : gl_config.theme.type});
      if(res_api.event_id){
        var movieDataToShow;
        if(gl_config.type == "site"){
          movieDataToShow = this.events.find((event) => event.id === res_api.event_id.slice(2));
        }else if(gl_config.type == "chain") {
          movieDataToShow = this.chain_events.find((event) => event.id === res_api.event_id.slice(2));
        }

        let title = movieDataToShow ? movieDataToShow.title : res_api.title ? res_api.title : "";
        let tab_title = title.split(":");
        let main_title = tab_title[0];
        let second_title = "";
        if(tab_title.length > 1){
          second_title = tab_title[1];
        }
        this.$main_title[0].textContent = main_title
        if(second_title != ""){
          this.$second_title[0].textContent = second_title
        }
        
        let img_url = res_api.url;
        if(is_on_mobile()){
          img_url = img_url.replace("/1920x","/600x");
          img_url = img_url.replace("/1920","/600");
        }else{
          // img_url = img_url.replace("/1920x","/960x");
          // img_url = img_url.replace("/1920","/960");
        }
        this.heroImage.attr({"src":img_url})
        this.heroContainer.on("click",() => {
          window.location.href = `#showmovie?id=${movieDataToShow.id}`;
        });
        this.$btn_call_to_action.on("click",() => {
          window.location.href = `#showmovie?id=${movieDataToShow.id}`;
        });

        $("nav").removeClass("black white");
        $(".hero-movie-title").removeClass("black white");
        $(".hero-side").removeClass("black white");
        $(".hero-builder").removeClass("black white");
        const colorThief = new ColorThief();
        const img = new Image();
        img.addEventListener('load', function() {
            let rgb = colorThief.getColor(img);
            // console.log("HeroBuilder - get_auto_banner_image - rgb image",rgb[0]+rgb[1]+rgb[2])
            // console.log("HeroBuilder - rgb image",rgb[0], rgb[1], rgb[2])
            // if(rgb[0]+rgb[1]+rgb[2]>350){
              $("nav").removeClass("black white");
              $(".hero-movie-title").removeClass("black white");
              $(".hero-side").removeClass("black white");
              $(".hero-builder").removeClass("black white");
            if(rgb[0]+rgb[1]+rgb[2]>500){
                if(!gl_config.website.style || !gl_config.website.style.navbar_transparency || gl_config.website.style.navbar_transparency == "with"){
                  $("nav").addClass("black");
                }
                $(".hero-movie-title").addClass("black");
                $(".hero-side").addClass("white");
                $(".hero-builder").addClass("white");
            }else{
                if(!gl_config.website.style || !gl_config.website.style.navbar_transparency || gl_config.website.style.navbar_transparency == "with"){
                  $("nav").addClass("white");
                }
                $(".hero-movie-title").addClass("white");
                $(".hero-side").addClass("black");
                $(".hero-builder").addClass("black");
            }
        });
        img.crossOrigin = 'Anonymous';
        img.src = img_url;
      }
    }catch(err){
      Swal.fire({
          icon:"warning",
          title:"Récupération image bannière",
          showCloseButton : true,
          text: _l(err.data ? err.data.message : err),
          heightAuto : false,
          scrollbarPadding : false,
          allowOutsideClick : false,
          customClass: {
              icon : "align-items-center"
          }
      }).then((result) => {
          // window.location.replace("#home");
      });
    }
  }

  // Fonction appelée lors du click sur un media
  set_media_action(iMedia) {
      // console.log(iMedia)
      if(iMedia.link && iMedia.link.type != "none"){            
          switch(iMedia.link.type){
              case "external_url":
                  window.open(iMedia.link.external_url,"_blank")
                  break;
              case "file":
                  // if(this.list_files){
                  //     let file_data = this.list_files.filter(file => file.id == iMedia.link.file_id)[0];
                  //     if(file_data){
                  //         const $link=$("<a/>").addClass("btn m-auto").attr({"id":"btn_download_file", "href":file_data.media_url, "download":file_data.name}).appendTo($("body"));
                  //         $("#btn_download_file").get(0).click();
                  //         $link.remove();
                  //     }
                  // }
                  break;
              case "movie": 
                  window.location.href = "#showmovie?id="+iMedia.link.movie_id;
                  break
              case "page":
                  window.location.href = "#"+iMedia.link.page_id;
                  break;
              case "session": 
                  window.location.href = "#showsession?id="+iMedia.link.session_id;
                  break;
              case "superbillet":
                  window.location.href = "#showsuperbillet?id="+iMedia.link.superbillet_id;
                  break;
              default:
                  break;
          }
      }
  }
}

